// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-select-dropdown__item{display:flex;justify-content:space-between;align-items:center}.el-select-dropdown__item>.label-left{text-overflow:ellipsis;white-space:normal;word-break:break-all;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1;overflow:hidden;line-height:normal}.el-select-dropdown__item>.label-right{flex-shrink:0;color:#8492a6;font-size:13px;margin-left:1rem;font-weight:400}", ""]);
// Exports
module.exports = exports;
